import { useNavigate } from "../hooks/navigateHook";
import { materializeValue } from "../utils/lazyValue";
import Button from "./Button";
import { withComponentCapabilities } from "./capabilities/componentCapabilities";
import { FloatingLabel } from "./FloatingLabel";
import Icon from "./Icon";
import PropTypes from 'prop-types';

export const toString = ({ def }) => materializeValue(def.text);

const LinkButton = ({ href, children }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(href, { target: '_blank' });
    };

    return (
        <Button className="p-0 text-start" variant="link" onClick={handleClick}>
            <Icon variant="solid" kind="link" style={{ fontSize: '6pt' }} />
            {' '}
            {children}
        </Button>
    );
};

/**
 * Render supplied text value directly as fixed text
 * @component
 */
const Label = withComponentCapabilities(({text, placeholder, href, hideLabel = false, style}) => {
    return <FloatingLabel hideLabel={hideLabel} placeholder={placeholder ?? ''} style={style} value={text} href={href}>
        {href && hideLabel ? (
                <LinkButton href={href}>{text ?? ''}</LinkButton>
            ) : (
                text ?? ''
            )}
    </FloatingLabel>
}, {
    lazyProps: ['text']
});

Label.propTypes = {
    /**
     * The text to be displayed
     */
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * An optional field label to be shown above the text
     */
    placeholder: PropTypes.string,

    /**
     * An option navigation URL to be followed if the label text is clicked
     */
    href: PropTypes.string,

    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool,
}

export default Label;